module.exports = __webpack_public_path__ + "img/alert-diamond.93d28c2b.svg";